/*
  HALO Academy editorial add-on for Dawn. Two jobs only - Dawn handles nav,
  cart drawer, search, etc. Loaded with defer.
    1. Scroll-reveal (.halo-reveal), respects prefers-reduced-motion
    2. Sticky product CTA - reveals once [data-halo-cta-anchor] scrolls away
*/
(function () {
  'use strict';
  document.documentElement.classList.remove('no-js');
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function reveal() {
    var els = document.querySelectorAll('.halo-reveal');
    if (!els.length) return;
    if (reduce || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-visible'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -10% 0px', threshold: 0.05 });
    els.forEach(function (el) { io.observe(el); });
  }

  function stickyCta() {
    var bar = document.querySelector('[data-halo-sticky-cta]');
    if (!bar) return;
    var anchor = document.querySelector('[data-halo-cta-anchor]');
    if (!anchor || !('IntersectionObserver' in window)) {
      var onScroll = function () { bar.classList.toggle('is-visible', window.scrollY > 600); };
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { bar.classList.toggle('is-visible', !e.isIntersecting); });
    }, { rootMargin: '0px 0px -20% 0px' });
    io.observe(anchor);
  }

  function header() {
    var el = document.querySelector('[data-halo-header]');
    if (!el || !el.classList.contains('halo-header--overlay')) return; // only the homepage overlay adapts
    var hero = document.querySelector('.halo-hero');
    var heroDark = !!(hero && hero.classList.contains('halo-content-inverse'));
    function atTop() { el.classList.remove('is-stuck'); el.setAttribute('data-tone', heroDark ? 'dark' : 'light'); }
    function stuck() { el.classList.add('is-stuck'); el.setAttribute('data-tone', 'light'); }
    atTop();
    if (hero && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { e.isIntersecting ? atTop() : stuck(); });
      }, { rootMargin: '-72px 0px 0px 0px', threshold: 0 });
      io.observe(hero);
    } else {
      var onScroll = function () { window.scrollY > 240 ? stuck() : atTop(); };
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
    }
  }

  // Mobile-Drawer. Wichtig: es gibt mehrere Wege heraus, damit man nie
  // feststeckt - Hamburger, Schliessen-Button im Overlay, Escape, Klick
  // daneben, Klick auf einen Link.
  function nav() {
    var toggles = document.querySelectorAll('[data-nav-toggle]');
    var closers = document.querySelectorAll('[data-nav-close]');
    var menu = document.querySelector('[data-nav-menu]');
    if (!toggles.length || !menu) return;
    function setOpen(open) {
      toggles.forEach(function (t) { t.setAttribute('aria-expanded', String(open)); });
      menu.toggleAttribute('data-open', open);
      document.body.classList.toggle('halo-nav-open', open);
    }
    toggles.forEach(function (t) {
      t.addEventListener('click', function () {
        setOpen(t.getAttribute('aria-expanded') !== 'true');
      });
    });
    closers.forEach(function (c) {
      c.addEventListener('click', function () { setOpen(false); });
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') setOpen(false); });
    document.addEventListener('click', function (e) {
      if (!menu.hasAttribute('data-open')) return;
      if (menu.contains(e.target)) return;
      for (var i = 0; i < toggles.length; i++) { if (toggles[i].contains(e.target)) return; }
      setOpen(false);
    });
    menu.querySelectorAll('a').forEach(function (a) { a.addEventListener('click', function () { setOpen(false); }); });
  }

  function megaMenu() {
    var li = document.querySelector('.halo-header__mega-li');
    var toggle = document.querySelector('[data-halo-mega-toggle]');
    if (!li || !toggle) return;
    function setOpen(open) {
      li.toggleAttribute('data-open', open);
      toggle.setAttribute('aria-expanded', String(open));
    }
    toggle.addEventListener('click', function (e) {
      e.preventDefault();
      setOpen(!li.hasAttribute('data-open'));
    });
    document.addEventListener('click', function (e) { if (!li.contains(e.target)) setOpen(false); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') setOpen(false); });
  }

  // Verfuegbarkeits-Labels im Produktbild an die Helligkeit des Motivs anpassen:
  // Gold auf dunklem, Ink auf hellem Untergrund. Motive koennen wechseln, darum
  // wird pro Bild die obere linke Ecke (wo das Label sitzt) ausgemessen.
  // Sampling ueber ein CORS-Probe-Bild; scheitert das (kein CORS), bleibt der
  // dunkle Gold-Fallback aus dem CSS. Das sichtbare <img> wird nie angefasst.
  function badgeTone() {
    var badges = document.querySelectorAll('.halo-card__badge');
    if (!badges.length) return;
    badges.forEach(function (badge) {
      var media = badge.closest('.halo-card__media');
      var img = media && media.querySelector('img.halo-card__img');
      var src = img && (img.currentSrc || img.src);
      if (!src) return;
      var probe = new Image();
      probe.crossOrigin = 'anonymous';
      probe.onload = function () {
        try {
          var nw = probe.naturalWidth, nh = probe.naturalHeight;
          if (!nw || !nh) return;
          var s = 12;
          var c = document.createElement('canvas');
          c.width = s; c.height = s;
          var ctx = c.getContext('2d');
          var rw = Math.max(1, Math.round(nw * 0.4));
          var rh = Math.max(1, Math.round(nh * 0.3));
          ctx.drawImage(probe, 0, 0, rw, rh, 0, 0, s, s);
          var d = ctx.getImageData(0, 0, s, s).data;
          var sum = 0, n = 0;
          for (var i = 0; i < d.length; i += 4) {
            var a = d[i + 3] / 255;
            sum += (0.2126 * d[i] + 0.7152 * d[i + 1] + 0.0722 * d[i + 2]) * a;
            n += a;
          }
          if (!n) return;
          badge.setAttribute('data-tone', (sum / n) > 150 ? 'light' : 'dark');
        } catch (e) { /* CORS/taint -> CSS-Fallback bleibt */ }
      };
      probe.src = src;
    });
  }

  function init() { reveal(); stickyCta(); nav(); header(); megaMenu(); badgeTone(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
